import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DevicesTable from "./data";
import AddDevicesModal from "./AddDevicesModel";
import Api from "../../api/api";

const Devices = () => {
  const [showModal, setShowModal] = useState(false);
  const [deviceList, setDeviceList] = useState([]);

  const fetchDeviceData = async () => {
    try {
      const devices = await Api.fetchDevices();
      if (Array.isArray(devices)) {
        setDeviceList(devices);
      } else if (Array.isArray(devices.data)) {
        setDeviceList(devices.data);
      } else {
        console.error("Unexpected device structure", devices);
      }
    } catch (error) {
      console.error("Failed to fetch devices", error);
    }
  };

  useEffect(() => {
    fetchDeviceData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Devices
                </MDTypography>
                <MDButton variant="contained" color="light" onClick={() => setShowModal(true)}>
                  + Add Devices
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <DevicesTable deviceList={deviceList} fetchDeviceData={fetchDeviceData} />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Card style={{ padding: "2rem", width: "500px", maxHeight: "90vh", overflowY: "auto" }}>
            <AddDevicesModal onClose={() => setShowModal(false)} onDeviceAdded={fetchDeviceData} />
          </Card>
        </div>
      )}
    </DashboardLayout>
  );
};

export default Devices;